module.exports = __webpack_public_path__ + "img/complaints.087eed4b.svg";